import {Mark, mergeAttributes} from "@tiptap/core";

export interface SmallCapsOptions {
	HTMLAttributes: any;
}

declare module "@tiptap/core" {
	interface Commands<ReturnType> {
		smallCaps: {
			setSmallCaps:    () => ReturnType;
			toggleSmallCaps: () => ReturnType;
			unsetSmallCaps:  () => ReturnType;
		};
	}
}

export const SmallCaps = Mark.create<SmallCapsOptions>({
	name: "smallCaps",
	addOptions() {
		return {
			HTMLAttributes: {
				style: "font-variant: small-caps"
			}
		};
	},
	parseHTML() {
		return [
			{
				style: "font-variant=small-caps"
			}
		];
	},
	renderHTML({HTMLAttributes}) {
		return ["span", mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
	},
	addCommands() {
		return {
			setSmallCaps: () => ({commands}) => {
				return commands.setMark("smallCaps");
			},
			toggleSmallCaps: () => ({commands}) => {
				return commands.toggleMark("smallCaps");
			},
			unsetSmallCaps: () => ({commands}) => {
				return commands.unsetMark("smallCaps");
			}
		};
	}
});
